import config from "config/appConfig";

import type { IStateProps } from "utils/StateOf";
import createStoreFunction from "utils/createStore";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.GITBOOK_DATA}`;

export interface Values {
	loading: boolean;

	loadingResponsibleGamingDocs: boolean;
	loadingKYCPolicyDocs: boolean;
	loadingAMLPolicyDocs: boolean;
	loadingPrivacyPolicyDocs: boolean;
	loadingTermsOfServiceDocs: boolean;

	responsibleGamingDocs: string;
	KYCPolicyDocs: string;
	AMLPolicyDocs: string;
	privacyPolicyDocs: string;
	termsOfServiceDocs: string;
}

export const initialState: IStateProps<Values> = {
	loading: false,

	loadingResponsibleGamingDocs: false,
	loadingKYCPolicyDocs: false,
	loadingAMLPolicyDocs: false,
	loadingPrivacyPolicyDocs: false,
	loadingTermsOfServiceDocs: false,

	responsibleGamingDocs: "",
	KYCPolicyDocs: "",
	AMLPolicyDocs: "",
	privacyPolicyDocs: "",
	termsOfServiceDocs: ""
};

export default createStoreFunction<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
